import { useState, useEffect } from 'react';
import LegalModal from './LegalModal';
import './cookie-banner.css';

const COOKIE_CONSENT_KEY = 'spiria_cookie_consent';

export default function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        // Check if user has already consented
        const hasConsented = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!hasConsented) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
        setIsVisible(false);
    };

    const openCookiePolicy = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    if (!isVisible) {
        return (
            <LegalModal 
                isOpen={isModalOpen} 
                onClose={closeModal} 
                type="cookies" 
            />
        );
    }

    return (
        <>
            <div className="cookie-banner">
                <div className="cookie-banner-content">
                    <p className="cookie-banner-text">
                        Мы используем файлы cookie для улучшения работы сайта и персонализации контента. 
                        Продолжая использовать сайт, вы соглашаетесь с нашей{' '}
                        <button 
                            className="cookie-banner-link-btn" 
                            onClick={openCookiePolicy}
                        >
                            политикой использования cookie
                        </button>.
                    </p>
                    <button 
                        className="cookie-banner-btn"
                        onClick={handleAccept}
                    >
                        Понятно
                    </button>
                </div>
            </div>
            <LegalModal 
                isOpen={isModalOpen} 
                onClose={closeModal} 
                type="cookies" 
            />
        </>
    );
}
